var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showData)?[_vm._v("; "),_c('vue-canvas-poster',{attrs:{"widthPixels":0,"painting":_vm.painting},on:{"success":_vm.success,"fail":_vm.fail}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }